import type { AppStore } from "./store";

/**
 * Access to the singleton store for non-React infrastructure code.
 *
 * `app/store` composes the root reducer out of every feature slice, so it sits
 * at the top of the import graph. Low-level modules (analytics, api clients)
 * that reach for `store.getState()` by importing `app/store` directly pull that
 * whole graph back down into themselves and create an import cycle. They import
 * this registry instead - `app/store` pushes the store in on creation, the same
 * way it registers a memory-stats provider.
 *
 * React code should keep using `useAppStore`/`useAppSelector` from
 * `app/redux-store-interactions`.
 */
let registeredStore: AppStore | undefined;

export function registerStore(store: AppStore): void {
    registeredStore = store;
}

/**
 * The singleton store, or `undefined` when `app/store` has not been loaded -
 * e.g. in unit tests that build their own store with `createStore()`.
 */
export function getRegisteredStore(): AppStore | undefined {
    return registeredStore;
}
